//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_MEDIOS_VERIFICACION = "obtenerMediosVerificacion";
export const OBTENER_MEDIOS_VERIFICACION_POR_PREGUNTA = "obtenerMediosVerificacionPregunta;"
export const OBTENER_MEDIO_VERIFICACION = "obtenerMedioVerificacion";
export const REGISTRAR_MEDIO_VERIFICACION = "registrarMedioVerificacion";
export const ACTUALIZAR_MEDIO_VERIFICACION = "actualizarMedioVerificacion";

export const REGISTRAR_MEDIO_VERIFICACION_PREGUNTA = "registrarMedioVerificacionRespuesta";
export const OBTENER_MEDIO_VERIFIFICACION_PREGUNTA = "obtenerMedioVerificacionPregunta";
export const ACTUALIZAR_MEDIO_VERIFICACION_RESPUESTA = "actualizarMedioVerificacionRespuesta";

// mutation types
export const SET_MEDIOS_VERIFICACION = "setMediosVerificacion";
export const SET_MEDIO_VERIFICACION = "setMedioVerificacion";
export const SET_MEDIOS_VERIFICACION_PREGUNTA = "setMediosVerificacionPregunta";
const state = {
    mediosVerificacion:[],
    medioVerificacion:[],
    mediosVerificacionPregunta:[],
    data: [
        {id:1, nombre: 'Fotografia de reuniones', descripcion: 'Este medio de verificación se utiliza en los casos', valorDefinido: '1 y 10', preguntasIdValorSeleccionado: null, estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 1}, 
        {id:2, nombre: 'Acta que respalda reuniones de comude', descripcion: 'Este medio de verificación se utiliza en los casos', valorDefinido: '01/01/2019 y 02/02/2021', preguntasIdValorSeleccionado: null, estadosId: 2, estado: 'Inactivo', indicesId: 1, preguntasId: 1},
        {id:3, nombre: 'Acta de última reunión', descripcion: 'Este medio de verificación se utiliza en los casos', valorDefinido: '0', estadosId: 1, preguntasIdValorSeleccionado: 1, estado: 'Activo', indicesId: 1, preguntasId: 2},
        {id:4, nombre: 'Foto de COMUDE', descripcion: 'Este medio de verificación se utiliza en los casos', valorDefinido: '10', estadosId: 1, preguntasIdValorSeleccionado: null, estado: 'Activo', indicesId: 1, preguntasId: 2},
        {id:5, nombre: 'Fecha Posterior que', descripcion: 'Este medio de verificación se utiliza en los casos', valorDefinido: '15/01/2020', preguntasIdValorSeleccionado: null, estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 3},
        {id:6, nombre: 'Fecha Anterior que', descripcion: 'Este medio de verificación se utiliza en los casos', valorDefinido: '01/01/2019', preguntasIdValorSeleccionado: null, estadosId: 2, estado: 'Inactivo', indicesId: 1, preguntasId: 3},
        
        
    ],

    
}

const getters = {
    obtenerMediosVerificacion(state) {
      return state.mediosVerificacion;
    },
}

const actions = {
    /**
     * Obtener medios de verificacion (todos o por estado)
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    async [OBTENER_MEDIOS_VERIFICACION](context, estadoId) {
        let endpoint = `api/MediosVerificacion`;
        if(estadoId!=0){
            endpoint = `api/MediosVerificacion/Estado/${estadoId}`
        }
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_MEDIOS_VERIFICACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        }); 
    },

    /**
     * Obtener Listado de MediosVerificacion por pregunta seleccionado
     * @param {*} context 
     * @param {*} indiceId 
     */
    async [OBTENER_MEDIOS_VERIFICACION_POR_PREGUNTA](context, datos){
        
        /*
        * Si el estado es 0 va a traer a todos los listas, de lo contrario va a traer los listas por estado
        *
        */
         let endpoint = `api/MedioVerificacionPregunta/all/${datos.preguntasId}`
         if(datos.estadoId>0){
             endpoint = `api/MedioVerificacionPregunta/Estado/${datos.estadoId}/${datos.preguntasId}`
         }
 
         return new Promise(resolve => {
             ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                 .then(({ data }) => {
                     context.commit(SET_MEDIOS_VERIFICACION_PREGUNTA, data.data);
                     resolve(data)
                 })
                 .catch((error) => {
                     resolve(error)
                     //context.commit(SET_ERROR, response.data.errors);
                 });
         }); 
    },

    async [OBTENER_MEDIO_VERIFICACION](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/MediosVerificacion/`)
                .then(({ data }) => {
                    context.commit(SET_MEDIO_VERIFICACION,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [REGISTRAR_MEDIO_VERIFICACION](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/MediosVerificacion`, datos)
                .then(({ data }) => {
                    context.commit(SET_MEDIO_VERIFICACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_MEDIO_VERIFICACION](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/MediosVerificacion/`, datos)
                .then(({ data }) => {
                    context.commit(SET_MEDIO_VERIFICACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [REGISTRAR_MEDIO_VERIFICACION_PREGUNTA](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/MedioVerificacionPregunta`, datos)
                .then(({ data }) => {
                    context.commit(SET_MEDIO_VERIFICACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [OBTENER_MEDIO_VERIFIFICACION_PREGUNTA](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/MedioVerificacionPregunta/`)
                .then(({ data }) => {
                    context.commit(SET_MEDIO_VERIFICACION,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_MEDIO_VERIFICACION_RESPUESTA](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/MedioVerificacionPregunta/`, datos)
                .then(({ data }) => {
                    context.commit(SET_MEDIO_VERIFICACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    
    

}

const mutations = {
    [SET_MEDIOS_VERIFICACION](state, data) {
        state.mediosVerificacion = data;
    },
    [SET_MEDIOS_VERIFICACION_PREGUNTA](state, data) {
        state.mediosVerificacionPregunta = data;
    },

    [SET_MEDIO_VERIFICACION](state, data) {
        state.medioVerificacion = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}